import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PlansService } from '../core/plans/plans.service';
import { MerchantSubscriptionService } from './subscription/merchant-subscription.service';
import {
  CapModalComponent,
  CapModalData
} from '../shared/components/cap-modal/cap-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CapModalService {
  private modalService = inject(NgbModal);
  private toastrService = inject(ToastrService);
  private plansService = inject(PlansService);
  private subscriptionService = inject(MerchantSubscriptionService);

  openCapModal(onSuccess?: () => void): void {
    this.plansService.getCurrentPlan().subscribe({
      next: response => {
        if (!response?.data?.plan) {
          this.toastrService.error('Failed to load plan data');
          return;
        }

        const plan = response.data.plan;
        const subscription = response.data.balance;

        const modalRef = this.modalService.open(CapModalComponent, {
          size: 'md',
          centered: true,
          backdrop: 'static'
        });

        modalRef.componentInstance.data = {
          planName: plan.name,
          ordersIncluded: plan.orderLimit,
          overagePrice: parseFloat(plan.overageRate),
          currentCap: parseFloat(subscription?.userCapAmount || plan.capAmount || '0'),
          maxCap: plan.maxCap
        };

        modalRef.result.then(
          (capAmount: number) => {
            this.subscriptionService.updateCapAmount(capAmount).subscribe({
              next: () => {
                this.toastrService.success('Cap settings updated successfully');
                if (onSuccess) {
                  onSuccess();
                } else {
                  this.subscriptionService.getSubscriptionStatus().subscribe();
                }
              },
              error: error => {
                const errorMessage = error?.message || 'Failed to update cap amount';
                this.toastrService.error(errorMessage);
              }
            });
          },
          () => {}
        );
      },
      error: () => {
        this.toastrService.error('Failed to load subscription data');
      }
    });
  }
}
